import httpAuth from '../../services/httpAuth'
import httpNotAuth from '../../services/httpNotAuth'
import getErrorMessage from '../../helpers/getErrorMessage.helper'
import { getLiveCasinoSearchSuccess, getLiveCasinoSearchError } from './liveCasinoSearch.slice'

import axios from 'axios'


export const requestLiveCasinoSearch = (name) => async (dispatch, getState) => {
    const checkAuth = getState().auth
    
    if(checkAuth) {
        try {
            const response = await httpAuth.get(`/casino/v2/games/search?query=${name}`)
           if (response.data.success) {
                dispatch(getLiveCasinoSearchSuccess(response.data.result))
            }
            return response
        } catch (e) {
            dispatch(getLiveCasinoSearchError())
            // const errorMsg = getErrorMessage(e)
            // throw errorMsg
        }
    } else {
        try {
            const response = await httpNotAuth.get(`/casino/v2/games/search?query=${name}`)
           if (response.data.success) {
                dispatch(getLiveCasinoSearchSuccess(response.data.result))
            }
            return response
        } catch (e) {
            dispatch(getLiveCasinoSearchError())
            // const errorMsg = getErrorMessage(e)
            // throw errorMsg
        }
    }
    
}

